/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Coverletter_DescInputs */

const en_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const de_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle überzeugende, personalisierte Anschreiben, die den Ton und die Werte des Unternehmens widerspiegeln. Wähle zwischen professionell, locker oder enthusiastisch.`)
};

const fr_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const es_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const it_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const nl_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const pl_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const fi_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const da_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

const sv_landing_tab_coverletter_desc = /** @type {(inputs: Landing_Tab_Coverletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles.`)
};

/**
* | output |
* | --- |
* | "Generate compelling, personalized cover letters that mirror the company's tone and values. Choose from professional, conversational, or enthusiastic styles." |
*
* @param {Landing_Tab_Coverletter_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_coverletter_desc = /** @type {((inputs?: Landing_Tab_Coverletter_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Coverletter_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_coverletter_desc(inputs)
	if (locale === "fr") return fr_landing_tab_coverletter_desc(inputs)
	if (locale === "es") return es_landing_tab_coverletter_desc(inputs)
	if (locale === "it") return it_landing_tab_coverletter_desc(inputs)
	if (locale === "nl") return nl_landing_tab_coverletter_desc(inputs)
	if (locale === "pl") return pl_landing_tab_coverletter_desc(inputs)
	if (locale === "fi") return fi_landing_tab_coverletter_desc(inputs)
	if (locale === "da") return da_landing_tab_coverletter_desc(inputs)
	if (locale === "sv") return sv_landing_tab_coverletter_desc(inputs)
	return en_landing_tab_coverletter_desc(inputs)
});